import { InviteLinkWithKey } from '@/includes/logic/InviteLinks/types'

export type InviteLinksState = {
	links: null | Array<InviteLinkWithKey>
}

export const inviteLinksState: InviteLinksState = {
	links: null,
}
